class ProductMediaModal {
  constructor(modal) {
    this.modal = modal;
    this.content = modal.querySelector('.product-media-modal__content');
    this.dialog = modal.querySelector('[role="dialog"]');
    this.closeButton = modal.querySelector('[id^="ModalClose-"]');
    this.openedBy = null;
    this.bindEvents();
    this.moveToBody();
  }

  moveToBody() {
    if (this.modal.dataset.moved === 'true') return;
    this.modal.dataset.moved = 'true';
    document.body.appendChild(this.modal);
  }

  bindEvents() {
    this.closeButton?.addEventListener('click', (event) => {
      event.preventDefault();
      this.hide();
    });

    this.modal.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.hide();
    });

    if (this.modal.classList.contains('media-modal')) {
      this.modal.addEventListener('pointerup', (event) => {
        if (event.pointerType !== 'mouse') return;
        if (
          event.target.closest(
            'deferred-media, product-model, .product-media-modal__toggle, .product-media-modal__image'
          )
        ) {
          return;
        }
        this.hide();
      });
    }
  }

  show(opener) {
    if (!opener) return;

    this.openedBy = opener;
    this.showActiveMedia();
    document.body.classList.add('overflow-hidden');
    this.modal.setAttribute('open', '');

    if (typeof trapFocus === 'function' && this.dialog) {
      trapFocus(this.modal, this.dialog);
    }

    if (typeof pauseAllMedia === 'function') pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.modal.removeAttribute('open');

    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.openedBy);
    if (typeof pauseAllMedia === 'function') pauseAllMedia();
  }

  showActiveMedia() {
    if (!this.content || !this.openedBy) return;

    const mediaId = this.openedBy.getAttribute('data-media-id');
    if (!mediaId) return;

    if (typeof pauseAllMedia === 'function') pauseAllMedia();

    this.content.querySelectorAll('[data-media-id]').forEach((element) => {
      element.classList.remove('active');
      element.setAttribute('hidden', '');
    });

    const activeMedia = this.content.querySelector(`[data-media-id="${mediaId}"]`);
    if (!activeMedia) return;

    activeMedia.classList.add('active');
    activeMedia.removeAttribute('hidden');

    const activeMediaTemplate = activeMedia.querySelector('template');
    const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

    if (
      activeMedia.nodeName === 'DEFERRED-MEDIA' &&
      activeMediaContent &&
      activeMediaContent.querySelector('.js-youtube') &&
      typeof activeMedia.loadContent === 'function'
    ) {
      activeMedia.loadContent();
    }
  }
}

const productMediaModalControllers = new WeakMap();

function getProductMediaModalController(modal) {
  if (!modal) return null;

  if (!productMediaModalControllers.has(modal)) {
    productMediaModalControllers.set(modal, new ProductMediaModal(modal));
  }

  const controller = productMediaModalControllers.get(modal);
  modal.show = (opener) => controller.show(opener);
  modal.hide = () => controller.hide();

  return controller;
}

function initProductMediaModals(root = document) {
  root.querySelectorAll('product-modal.product-media-modal, .product-media-modal').forEach((modal) => {
    getProductMediaModalController(modal);
  });
}

function handleProductImageZoom(event) {
  const opener = event.target.closest('.product__modal-opener--image');
  if (!opener) return;

  if (event.target.closest('.product-gallery__shop-the-look-btn')) return;

  const modalSelector = opener.getAttribute('data-modal');
  if (!modalSelector) return;

  const modal = document.querySelector(modalSelector);
  if (!modal) return;

  const trigger = opener.querySelector('[data-media-id]');
  if (!trigger) return;

  event.preventDefault();
  event.stopPropagation();

  getProductMediaModalController(modal)?.show(trigger);
}

function bootProductMediaModal() {
  if (window.__productMediaModalBooted) return;
  window.__productMediaModalBooted = true;

  initProductMediaModals();
  document.addEventListener('click', handleProductImageZoom, true);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootProductMediaModal);
} else {
  bootProductMediaModal();
}

window.initProductMediaModals = initProductMediaModals;
